import { render, staticRenderFns } from "./UiTip.vue?vue&type=template&id=e7333ebc"
import script from "./UiTip.vue?vue&type=script&lang=js"
export * from "./UiTip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports